import { render, staticRenderFns } from "./QMenuTree.vue?vue&type=template&id=5955c740&lang=pug&"
import script from "./QMenuTree.vue?vue&type=script&lang=ts&"
export * from "./QMenuTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports